import { useContext } from 'react';
import { ModalBase, ModalHeader, Separators, Tab } from 'components';
import { AudienceSettingsTab } from './audienceSettingsTab/AudienceSettingsTab';
import { AssociatedCampaignsTab } from './associatedCampaignsTab/AssociatedCampaignsTab';
import { useSignal, useComputed } from '@preact/signals-react';
import { ChooseAudienceManagementContext } from 'contexts';

const pages = {
  audienceSettings: AudienceSettingsTab,
  associatedCampaigns: AssociatedCampaignsTab,
};

export const ChooseAudienceManagement = ({ closeModal }) => {
  const openedPage$ = useSignal('audienceSettings');
  const ComponentToShow$ = useComputed(() => pages[openedPage$.value]);
  const { campaigns } = useContext(ChooseAudienceManagementContext);

  return (
    <ModalBase>
      <ModalHeader title='Edit Audience' close={closeModal} />
      <div style={{ display: 'flex', padding: '0 24px', gap: '24px' }}>
        <Tab
          onChange={() => {
            openedPage$.value = 'audienceSettings';
          }}
          value={'audienceSettings'}
          label='Audience Settings'
          pressed={openedPage$.value === 'audienceSettings'}
        />
        <Tab
          onChange={() => {
            openedPage$.value = 'associatedCampaigns';
          }}
          value={'associatedCampaigns'}
          label='Associated Campaigns'
          pressed={openedPage$.value === 'associatedCampaigns'}
          disabled={!campaigns}
        />
      </div>
      <Separators type={Separators.separatorTypes.small} />
      <ComponentToShow$.value closeModal={closeModal} />
    </ModalBase>
  );
};
